import { render, staticRenderFns } from "./BillingUsage.vue?vue&type=template&id=2bad5746&scoped=true"
import script from "./BillingUsage.vue?vue&type=script&lang=js"
export * from "./BillingUsage.vue?vue&type=script&lang=js"
import style0 from "./BillingUsage.vue?vue&type=style&index=0&id=2bad5746&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bad5746",
  null
  
)

export default component.exports